import axios from "axios";
import { setCookie, getCookie } from "utils/utils";

const requestSMS = axios.create({
  // baseURL: CONFIG.API_HOST,
  baseURL: process.env.REACT_APP_API_HOST,
  timeout: 100000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
});

const requestDefault = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  timeout: 100000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
});

const requestNew = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

class api {
  constructor(token) {
    this.token = "";
  }

  GetSource = async (query, url) => {
    let option = {};
    option.params = query;
    return requestNew.get(url, option);
  };

  LOGIN = () => {
    let query = {
      SysName: "UniMarginWeb",
      Password: "n7kzDhae",
      ExpiresHour: 24,
    };

    if (process.env.REACT_APP_ENV === "production") {
      query.SysName = "UniMarginWeb";
      query.Password = "n7kzDhae";
    }
    return requestNew.post("/api/auth/Login", query);
  };

  getWebTeamToken = () => {
    const token = getCookie("webTeamToken");

    if (token) {
      return token;
    }

    let query = {
      SysName: "UniMarginWeb",
      Password: "n7kzDhae",
      ExpiresHour: 24,
    };

    if (process.env.REACT_APP_ENV === "production") {
      query.SysName = "UniMarginWeb";
      query.Password = "n7kzDhae";
    }

    return requestNew
      .post("/api/auth/Login", query)
      .then((res) => {
        const newToken = res.data.Content;
        setCookie("webTeamToken", newToken, 30);
        return newToken;
      })
      .catch((err) => {
        throw err;
      });
  };

  POST_NEW = (url, query) => {
    return requestNew.post(url, query);
  };

  GET = (url, query) => {
    // let option = this.getHeader()
    let option = {};
    option.params = query;
    return requestDefault.get(url, option);
  };

  POST = (url, query) => {
    return requestDefault.post(url, query);
  };

  POST_UPLOAD = (url, query) => {
    return requestDefault.post(url, query);
  };

  POST_SMS = (url, query) => {
    return requestSMS.post(url, query);
  };

  getWebTeam = async (url, query) => {
    let options = {};

    const webTeamToken = await this.getWebTeamToken();

    options = {
      headers: {
        Authorization: webTeamToken,
        "Content-Type": "application/json",
      },
    };

    if (query) {
      options.params = query;
    }

    return requestNew.get(url, options);
  };

  postWebTeam = async (url, query) => {
    let options = {};
    const webTeamToken = await this.getWebTeamToken();

    options = {
      headers: {
        Authorization: webTeamToken,
        "Content-Type": "application/json",
      },
    };

    return requestNew.post(url, query, options);
  };
}

export default new api();
